import { TooltipProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

declare module '@mui/material/Tooltip' {
  interface TooltipProps {
    mode?: 'light' | 'dark';
    size?: 'small' | 'medium';
    maxWidth?: 'default' | 'unset';
  }
}

export default function Tooltip(theme: Theme) {
  const tooltipStyles = (ownerState: TooltipProps) => {
    const sizeSmall = ownerState.size === 'small';
    const isDarkMode = ownerState.mode === 'dark';
    const maxWidth = ownerState.maxWidth === 'unset' ? 'unset' : 'default';

    return {
      backgroundColor: !isDarkMode
        ? theme.palette.common.white
        : theme.palette.grey[500],
      color: !isDarkMode ? theme.palette.grey[500] : theme.palette.common.white,
      // boxShadow: theme.shadows[1],
      padding: theme.spacing(0.5, 1),
      ...theme.typography.body5,
      ...(maxWidth === 'unset' && {
        maxWidth: 'unset',
      }),
    };
  };

  const arrowStyles = (ownerState: TooltipProps) => {
    const isDarkMode = ownerState.mode === 'dark';
    return {
      color: !isDarkMode ? theme.palette.common.white : theme.palette.grey[500],
      '&::before': {
        // boxShadow: !isDarkMode ? theme.shadows[1] : theme.shadows[0],
      },
    };
  };

  const popperStyles = {
    // Fix gap between arrow and tooltip body for each placement
    '&[data-popper-placement*="right"] .MuiTooltip-arrow': {
      left: '1px !important',
    },
    '&[data-popper-placement*="left"] .MuiTooltip-arrow': {
      right: '1px !important',
    },
  };

  return {
    MuiTooltip: {
      defaultProps: {
        arrow: true,
        size: 'small',
        mode: 'dark',
      },

      styleOverrides: {
        popper: popperStyles,
        tooltip: ({ ownerState }: { ownerState: TooltipProps }) =>
          tooltipStyles(ownerState),
        arrow: ({ ownerState }: { ownerState: TooltipProps }) =>
          arrowStyles(ownerState),
      },
    },
  };
}
